import Vue from 'vue'

const trackedBillAssignment = {
  state: {
    trackedBillAssignments: [],
    selectedTrackedBillAssignment: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    trackedBillAssignments(state) {
      return state.trackedBillAssignments
    },
    selectedTrackedBillAssignment(state) {
      return state.selectedTrackedBillAssignment
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    trackedBillAssignments(state, payload) {
      state.trackedBillAssignments = payload
    },
    selectedTrackedBillAssignment(state, payload) {
      state.selectedTrackedBillAssignment = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedTrackedBillAssignment(context, payload) {
      context.commit('selectedTrackedBillAssignment', payload)
    },
    loadTrackedBillAssignments(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'TrackedBillAssignment'
        context.commit('increaseSearchCount')
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('trackedBillAssignments', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    refreshSelectedTrackedBillAssignment(context, payload) {
      if (
        context.state.selectedTrackedBillAssignment &&
        context.state.selectedTrackedBillAssignment.TrackedBillID
      ) {
        context.dispatch(
          'loadSelectedTrackedBillAssignment',
          context.state.selectedTrackedBillAssignment.TrackedBillID
        )
      }
      if (
        context.state.selectedTrackedBillAssignment &&
        context.state.selectedTrackedBillAssignment.UserID
      ) {
        context.dispatch(
          'loadSelectedTrackedBillAssignment',
          context.state.selectedTrackedBillAssignment.UserID
        )
      }
    },
    loadSelectedTrackedBillAssignment(context, payload) {
      if (
        context.state.selectedTrackedBillAssignment &&
        context.state.selectedTrackedBillAssignment.TrackedBillID != payload
      ) {
        context.commit('selectedTrackedBillAssignment', {})
      }
      if (
        context.state.selectedTrackedBillAssignment &&
        context.state.selectedTrackedBillAssignment.UserID != payload
      ) {
        context.commit('selectedTrackedBillAssignment', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'TrackedBillAssignment/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedTrackedBillAssignment', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    clearLookupCacheAndReloadTrackedBillAssignments(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
        context.dispatch('loadTrackedBillAssignments')
      })
    },
    createTrackedBillAssignment(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `TrackedBillAssignment`
        context.commit('saving', true)
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'tracked bill assignment created' },
              { root: true }
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadTrackedBillAssignments')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
  },
}

export default trackedBillAssignment
